import { render, staticRenderFns } from "./SellingReportMaterialGrouped.vue?vue&type=template&id=87c791dc"
import script from "./SellingReportMaterialGrouped.vue?vue&type=script&lang=js"
export * from "./SellingReportMaterialGrouped.vue?vue&type=script&lang=js"
import style0 from "./SellingReportMaterialGrouped.vue?vue&type=style&index=0&id=87c791dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports